<button
  class="rounded-circle border border-2 border-dark bg-white p-2 fw-bold"
  [matMenuTriggerFor]="menu"
  aria-label="User button with a menu"
  [matTooltip]="'User Menu'"
>
  {{ initials }}
</button>
<mat-menu #menu="matMenu" class="w-60">
  <div class="d-flex flex-column border-bottom-2 p-2 fs-6">
    <span class="fw-bold">{{ name }}</span>
    <span class="text-accent">{{ email }}</span>
  </div>
  <button mat-menu-item (click)="logout()">
    <span>Logout</span>
  </button>
</mat-menu>
